import { render, staticRenderFns } from "./ajbar.vue?vue&type=template&id=1b4b2a02&"
import script from "./ajbar.vue?vue&type=script&lang=js&"
export * from "./ajbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports